module.exports = __webpack_public_path__ + "static/media/InstructionsIcon.9842bbb8.svg";